import {
  SET_ANSWER,
  DELETE_ANSWER,
  SET_ANSWERS,
  SET_QUIZ_TYPES,
  SET_QUIZ_ANSWERS,
} from "../actions";
import { SET_PROFILE } from "../actions/actionsTypes";
import { steps } from "../steps";

const initialState = {
  [steps[0].id]: {
    answers: [],
  },
  quizTypes: [],
  quizAnswers: {
    [steps[0].id]: {},
  },
  user: {},
};

export const onboardingReducer = (state = initialState, action) => {
  const { type } = action;

  if (type === SET_ANSWER) {
    const { step, answer } = action.payload;

    return {
      ...state,
      [step]: {
        answers: [...state[step].answers, answer],
      },
    };
  }

  if (type === SET_ANSWERS) {
    const { step, answers } = action.payload;

    return {
      ...state,
      [step]: {
        answers,
      },
    };
  }

  if (type === DELETE_ANSWER) {
    const { step, answerId } = action.payload;
    return {
      ...state,
      [step]: {
        answers: state[step].answers.filter(
          (answer) => Number(answer.id) !== Number(answerId)
        ),
      },
    };
  }

  if (type === SET_QUIZ_TYPES) {
    const { quizTypes } = action.payload;

    return {
      ...state,
      quizTypes,
    };
  }

  if (type === SET_QUIZ_ANSWERS) {
    const { step, quizAnswers } = action.payload;

    return {
      ...state,
      quizAnswers: {
        ...state.quizAnswers,
        [step]: quizAnswers,
      },
    };
  }

  if (type === SET_PROFILE) {
    const { participantProfile } = action.payload;

    return {
      ...state,
      user: {
        ...state.user,
        ...participantProfile,
      },
    };
  }

  return state;
};
